import * as types from "./constant"

// Add Mutual Fund 
export const addMutualFundStart = payload => {
    return {
        type: types.ADD_MUTUAL_FUND_START,
        payload,
    }
}

export const addMutualFundSuccess = payload => {
    return {
        type: types.ADD_MUTUAL_FUND_SUCCESS,
        payload,
    }
}

export const addMutualFundFailure = error => ({
    type: types.ADD_MUTUAL_FUND_FAILURE,
    payload: error,
})

export const addMutualFundReset = () => ({
    type: types.ADD_MUTUAL_FUND_RESET,
})


// Update Mutual Fund
export const updateMutualFundStart = payload => {
    return {
        type: types.UPDATE_MUTUAL_FUND_START,
        payload,
    }
}

export const updateMutualFundSuccess = payload => {
    return {
        type: types.UPDATE_MUTUAL_FUND_SUCCESS,
        payload,
    }
}

export const updateMutualFundFailure = error => ({
    type: types.UPDATE_MUTUAL_FUND_FAILURE,
    payload: error,
})

export const updateMutualFundReset = () => ({
    type: types.UPDATE_MUTUAL_FUND_RESET,
})


// View Customer Mutual Fund 

export const viewCustomerMutualFundStart = payload => {
    return {
        type: types.VIEW_CUSTOMER_MUTUAL_FUND_START,
        payload,
    }
}

export const viewCustomerMutualSuccess = payload => {
    return {
        type: types.VIEW_CUSTOMER_MUTUAL_FUND_SUCCESS,
        payload,
    }
}

export const viewCustomerMutualFundFailure = error => ({
    type: types.VIEW_CUSTOMER_MUTUAL_FUND_FAILURE,
    payload: error,
})

export const viewCustomerMutualFundReset = () => ({
    type: types.VIEW_CUSTOMER_MUTUAL_FUND_RESET,
})


// View Single Mutual Fund

export const viewSingleMutualFundStart = payload => {
    return {
        type: types.VIEW_SINGLE_MUTUAL_FUND_START,
        payload,
    }
}

export const viewSingleMutualFundSuccess = payload => {
    return {
        type: types.VIEW_SINGLE_MUTUAL_FUND_SUCCESS,
        payload,
    }
}

export const viewSingleMutualFundFailure = error => ({
    type: types.VIEW_SINGLE_MUTUAL_FUND_FAILURE,
    payload: error,
})

export const viewSingleMutualFundReset = () => ({
    type: types.VIEW_SINGLE_MUTUAL_FUND_RESET,
})

// MUTUAL FUND REPORT
export const mutualFundReportStart = payload => ({
    type: types.MUTUAL_FUND_REPORT_START,
    payload,
});

export const mutualFundReportSuccess = data => ({
    type: types.MUTUAL_FUND_REPORT_SUCCESS,
    payload: data,
});

export const mutualFundReportFailure = error => ({
    type: types.MUTUAL_FUND_REPORT_FAILURE,
    payload: error,
});

export const mutualFundReportReset = () => ({
    type: types.MUTUAL_FUND_REPORT_RESET,
});